import React from 'react';

export default class Page7 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="desktop ipad-portrait-show">
                                                <table
                                                    className="ilead_v_sport tablesrink uiheading ilead_v_sport_center"
                                                    border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve " align="left" valign="top"
                                                            width="10%">Strength
                                                        </th>
                                                        <th align="left" valign="top" width="20%">Characterised
                                                            by…
                                                        </th>

                                                        <th className=" green_curve1" align="left" valign="top"
                                                            width="20%">How to use it…
                                                        </th>

                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="10%">Planner
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>You have a natural affinity for
                                                            project planning. You like
                                                            planning, organisation and
                                                            structure and working to
                                                            timeframes and deadlines. You
                                                            like breaking projects down into
                                                            smaller, achievable tasks.</p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>You’ll be great at managing your
                                                            resources but
                                                            first you need to get them! Plan your project in
                                                            detail to show how it would work and why you
                                                            need the resources you’ve described but be
                                                            careful of seeming inflexible. Don’t come across
                                                            as a bit of a ‘control freak!’
                                                        </p>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="10%">Empathiser
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%"><p>You’re able to see things from
                                                            others’ perspectives whether
                                                            you agree or not and are able
                                                            to anticipate their needs. You
                                                            choose your words and tone to
                                                            suit circumstances and people.</p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%"><p>Use your empathetic skills to
                                                            anticipate objections
                                                            with prepared answers. However, don’t be so
                                                            concerned with what others want that you
                                                            become distracted from your original purpose.</p>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="10%">Innovator
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>You can energise people with
                                                            your imagination and
                                                            enthusiasm for finding ways to
                                                            improve or invent ideas,
                                                            processes and methods.</p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>Use your creativity to inspire and
                                                            engage people
                                                            but be careful to include practical detail –
                                                            remember some people can’t visualise things as
                                                            easily as you and are wary of change.</p>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="10%">Optimist
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%"><p>You are quick to give praise,
                                                            optimistic and enthusiastic.
                                                            Others like to be around you
                                                            and your enthusiasm’s
                                                            contagious! You make every
                                                            project exciting and celebrate
                                                            all achievements.</p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%"><p>Use your ability to get people to
                                                            like you and feel
                                                            your enthusiasm to get them ‘on side’. Tell them
                                                            about past achievements to build their confidence
                                                            in what you are proposing now. Play on the
                                                            excitement that you are able to create in them to
                                                            gain the resources you need. However, be careful
                                                            not to let your positivity blind you to potential
                                                            risks.</p>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="10%">Problem solver
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>You love the challenge of
                                                            identifying underlying problems
                                                            and finding solutions. </p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>Use your love of problem solving to
                                                            structure your
                                                            approach in two ways. First, explain the problems
                                                            you’ve identified and their implications, then
                                                            describe your solution, how it will work and its
                                                            benefits. Secondly, treat winning resources as a
                                                            problem solving exercise in itself. If you don’t get
                                                            agreement, ask if you can have more time – you
                                                            might offer previously overlooked solutions and
                                                            impress with your tenacity and ingenuity!</p>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="10%">Self-assured
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%"><p>You’re sure of your abilities and
                                                            judgement, so exude and invite
                                                            confidence. </p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%"><p>Your air of confidence and track
                                                            record will
                                                            help persuade that you’re able to deliver, but
                                                            don’t appear arrogant.</p>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="10%">People person
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>You’re great at winning people
                                                            over. You like meeting new
                                                            people and find it easy to
                                                            build rapport.</p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>Being able to build rapport is a
                                                            great strength
                                                            as people will like you and are more likely to be
                                                            receptive. Use your skills to gain commitment
                                                            but be careful not to become complacent. It’s
                                                            not enough that people like you; you still need to
                                                            put forward a good business case!</p>
                                                        </td>

                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>


                                            <div className="mobile ipad-portrait-hide">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport tablesrink para-bottompad">

                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" width="50%">Strength</th>
                                                        <td className="lightgreen"
                                                            style={{borderTopRightRadius: '15px'}} align="left"
                                                            width="10%" valign="top">Planner
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th align="left" valign="top" width="20%">Characterised
                                                            by…
                                                        </th>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%">
                                                            <p>You have a natural affinity for project planning.
                                                                You like planning, organisation and structure
                                                                and working to timeframes and deadlines. You
                                                                like breaking projects down into smaller,
                                                                achievable tasks.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" darkgreen"
                                                            style={{borderBottomLeftRadius: '15px'}}
                                                            align="left" width="20%" valign="top">How to use it…
                                                        </th>
                                                        <td className="lightgreen"
                                                            style={{borderBottomRightRadius: '15px'}}
                                                            align="left" width="20%" valign="top">
                                                            <p>You’ll be great at managing your resources but
                                                                first you need to get them! Plan your project in
                                                                detail to show how it would work and why you
                                                                need the resources you’ve described but be
                                                                careful of seeming inflexible. Don’t come across
                                                                as a bit of a ‘control freak!’ </p>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th className="green_curve" width="50%">Strength</th>
                                                        <td className="darkgreen"
                                                            id="yui_3_17_2_1_1516011044300_28"
                                                            style={{borderTopRightRadius: '15px'}} align="left"
                                                            width="10%" valign="top">Empathiser
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th align="left" valign="top" width="20%">Characterised
                                                            by…
                                                        </th>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%">
                                                            <p>You’re able to see things from others’
                                                                perspectives whether you agree or not and are
                                                                able to anticipate their needs. You choose your
                                                                words and tone to suit circumstances and
                                                                people.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" darkgreen"
                                                            style={{borderBottomLeftRadius: '15px'}}
                                                            align="left" width="20%" valign="top">How to use it…
                                                        </th>
                                                        <td className="darkgreen"
                                                            style={{borderBottomRightRadius: '15px'}}
                                                            align="left" valign="top" width="20%">
                                                            <p>Use your empathetic skills to anticipate
                                                                objections with prepared answers. However, don’t
                                                                be so concerned with what others want that you
                                                                become distracted from your original purpose</p>
                                                        </td>

                                                    </tr>


                                                    <tr>
                                                        <th className="green_curve" width="50%">Strength</th>
                                                        <td className="lightgreen"
                                                            style={{borderTopRightRadius: '15px'}} align="left"
                                                            width="10%" valign="top">Innovator
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th align="left" valign="top" width="20%">Characterised
                                                            by…
                                                        </th>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%">
                                                            <p>You can energise people with your imagination and
                                                                enthusiasm for finding ways to improve or invent
                                                                ideas, processes and methods.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" darkgreen"
                                                            style={{borderBottomLeftRadius: '15px'}}
                                                            align="left" width="20%" valign="top">How to use it…
                                                        </th>
                                                        <td className="lightgreen"
                                                            style={{borderBottomRightRadius: '15px'}}
                                                            align="left" width="20%" valign="top">
                                                            <p>Use your creativity to inspire and engage people
                                                                but be careful to include practical detail –
                                                                remember some people can’t visualise things as
                                                                easily as you and are wary of change.</p>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <th className="green_curve" width="50%">Strength</th>
                                                        <td className="darkgreen"
                                                            id="yui_3_17_2_1_1516011044300_28"
                                                            style={{borderTopRightRadius: '15px'}} align="left"
                                                            width="10%" valign="top">Optimist
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th align="left" valign="top" width="20%">Characterised
                                                            by…
                                                        </th>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%">
                                                            <p>You are quick to give praise, optimistic and
                                                                enthusiastic. Others like to be around you and
                                                                your enthusiasm’s contagious! You make every
                                                                project exciting and celebrate all
                                                                achievements.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" darkgreen"
                                                            style={{borderBottomLeftRadius: '15px'}}
                                                            align="left" width="20%" valign="top">How to use it…
                                                        </th>
                                                        <td className="darkgreen"
                                                            style={{borderBottomRightRadius: '15px'}}
                                                            align="left" valign="top" width="20%">
                                                            <p>Use your ability to get people to like you and
                                                                feel your enthusiasm to get them ‘on side’. Tell
                                                                them about past achievements to build their
                                                                confidence in what you are proposing now. Play
                                                                on the excitement that you are able to create in
                                                                them to gain the resources you need. However, be
                                                                careful not to let your positivity blind you to
                                                                potential risks.</p>
                                                        </td>

                                                    </tr>


                                                    <tr>
                                                        <th className="green_curve" width="50%">Strength</th>
                                                        <td className="lightgreen"
                                                            style={{borderTopRightRadius: '15px'}} align="left"
                                                            width="10%" valign="top">Problem solver
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th align="left" valign="top" width="20%">Characterised
                                                            by…
                                                        </th>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%">
                                                            <p>You love the challenge of identifying underlying
                                                                problems and finding solutions. </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" darkgreen"
                                                            style={{borderBottomLeftRadius: '15px'}}
                                                            align="left" width="20%" valign="top">How to use it…
                                                        </th>
                                                        <td className="lightgreen"
                                                            style={{borderBottomRightRadius: '15px'}}
                                                            align="left" width="20%" valign="top">
                                                            <p>Use your love of problem solving to structure
                                                                your approach in two ways. First, explain the
                                                                problems you’ve identified and their
                                                                implications, then describe your solution, how
                                                                it will work and its benefits. Secondly, treat
                                                                winning resources as a problem solving exercise
                                                                in itself. If you don’t get agreement, ask if
                                                                you can have more time – you might offer
                                                                previously overlooked solutions and impress with
                                                                your tenacity and ingenuity!</p>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th className="green_curve" width="50%">Strength</th>
                                                        <td className="darkgreen"
                                                            id="yui_3_17_2_1_1516011044300_28"
                                                            style={{borderTopRightRadius: '15px'}} align="left"
                                                            width="10%" valign="top">Self-assured
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th align="left" valign="top" width="20%">Characterised
                                                            by…
                                                        </th>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%">
                                                            <p>You’re sure of your abilities and judgement, so
                                                                exude and invite confidence. </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" darkgreen"
                                                            style={{borderBottomLeftRadius: '15px'}}
                                                            align="left" width="20%" valign="top">How to use it…
                                                        </th>
                                                        <td className="darkgreen"
                                                            style={{borderBottomRightRadius: '15px'}}
                                                            align="left" valign="top" width="20%">
                                                            <p>Your air of confidence and track record will help
                                                                persuade that you’re able to deliver, but don’t
                                                                appear arrogant.</p>
                                                        </td>

                                                    </tr>


                                                    <tr>
                                                        <th className="green_curve" width="50%">Strength</th>
                                                        <td className="lightgreen"
                                                            style={{borderTopRightRadius: '15px'}} align="left"
                                                            width="10%" valign="top">People person
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th align="left" valign="top" width="20%">Characterised
                                                            by…
                                                        </th>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%">
                                                            <p>You’re great at winning people over. You like
                                                                meeting new people and find it easy to build
                                                                rapport.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" darkgreen"
                                                            style={{borderBottomLeftRadius: '15px'}}
                                                            align="left" width="20%" valign="top">How to use it…
                                                        </th>
                                                        <td className="lightgreen"
                                                            style={{borderBottomRightRadius: '15px'}}
                                                            align="left" width="20%" valign="top">
                                                            <p>Being able to build rapport is a great strength
                                                                as people will like you and are more likely to
                                                                be receptive. Use your skills to gain commitment
                                                                but be careful not to become complacent. It’s
                                                                not enough that people like you; you still need
                                                                to put forward a good business case!</p>
                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>
                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page8')}
                                                     className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}